const getPagination = (state) => state.get('pagination');
export const getCurrentPage = (state) =>
  getPagination(state).get('currentPage');
export const getPagesCount = (state) => getPagination(state).get('pagesCount');
export const getLinkBase = (state) => getPagination(state).get('linkBase');
